
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/article/[articleSlug]",
      function () {
        return require("private-next-pages/blog/article/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/article/[articleSlug]"])
      });
    }
  